import React, { Component } from "react"
import { Container, Row, Col, Button } from 'react-bootstrap'
import { connect } from "react-redux";

import PageBanner from "../../common/page/PageBanner";
import CountyNotes from "../../common/page/CountyNotes";

import SelectField from "../../common/form/SelectField";

import GrantorGranteeBookSearchResultsDetails from "./GrantorGranteeBookSearchResultsDetails";
import GrantorGranteeBookSearchResultsTable from "./GrantorGranteeBookSearchResultsTable";

import { caretSquareDownIcon, caretSquareUpIcon, minusIcon, filterIcon } from "../../../img/font_awesome/font_awesome"

import { searchResultsSort } from "../../../redux/actions/searchActions";

import { LOADING_STATUES } from "../../constants/constants";
import Loading from '../../common/modal/Loading';

const matchDispatchToProps = (dispatch) => {
    return { 
      searchResultsSort: (sort, currentSearch, history, callback) => dispatch(searchResultsSort(sort, currentSearch, history, callback)),
      filteredResultsSort: (sortKey, sortDirection) => dispatch({ type: 'SORT_FILTERED_GRANTOR_GRANTEE_BOOK', sortKey, sortDirection }),
      setSearchResultsSort: (sortKey, sortDirection) => dispatch({ type: 'SET_SELECTED_SEARCH_RESULTS_SORT', sort: {sortKey, sortDirection }}),

      paginate: (pageNumber) => dispatch({ type: 'SET_SELECTED_SEARCH_RESULTS_PAGE', pageNumber }),
      showFilteredResults: (searchResults) => dispatch({ type: 'SHOW_FILTERED_SEARCH_RESULTS', searchResults }),  // This is the search results table
      applySearchResultsFilter: (applyFilter) => dispatch({ type: 'APPLY_SEARCH_RESULTS_FILTER', applyFilter}),
      resetRead: () =>  dispatch({ type: 'RESET_READ'})
    }
}

const mapStateToProps = state => {
    return {
        sideNavigationOpen: state.sideNavigationReducer,
        currentSearch: state.searchHistoryReducer.searchHistoryList[0],
        searchResults: state.searchResultsReducer,
        pageNumber: state.searchResultsPaginationReducer,
        filteredDocuments: state.searchResultsFilterGrantorGranteeBookReducer,         
        filterApplied: state.searchResultsFilterAppliedFilter,
        searchResultsVisited: state.searchResultsVisitedReducer,
        searchResultsVisitedApplied: state.searchResultsVisitedAppliedReducer   
    };
}

class GrantorGranteeBookSearchResults extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchResultsSort: 'id',   // Reference ID is the default sort
            searchResultsSortDirection: 'ASC',
            loadingStatus: ""
        }    
    }

    showLoading = () => {
        if (this.state.loadingStatus === "") {
          this.setState({
            loadingStatus: LOADING_STATUES.LOADING
          })
          return true;
        } 
        return false;
      }

    hideLoading = (message, status) => {
          this.setState({
            loadingStatus: ""
          })
    }

    handleChange = (event) => {
        this.setState(
            {
                searchResultsSort: event.target.value
            },
            function() {   // callback function after the state is set
                this.handleSort();
            }
        )
    }

    handleClick = () => {
        this.setState(
            {
                searchResultsSortDirection: this.state.searchResultsSortDirection === 'ASC'? 'DESC' : 'ASC'
            },
            function() {   // callback function after the state is set
                this.handleSort();
            }
        )
    }

    handleSort = () => {
        if (this.props.filterApplied === true) {
            this.props.filteredResultsSort(this.state.searchResultsSort, this.state.searchResultsSortDirection);
            this.props.setSearchResultsSort(this.state.searchResultsSort, this.state.searchResultsSortDirection);
        } else if (this.showLoading() === true) {
            const { loadingStatus, imagingWindows, alertWindow, ...request } = this.state; // remove UI only fields before submitting
            const request1 = Object.assign(request, { pageNumber: this.props.pageNumber });
		    this.props.searchResultsSort(request1, this.props.currentSearch, this.props.history, this.hideLoading);
        }
	}

    handleApplyFilter = (event) => {    
        event.preventDefault();   
        if (this.props.filterApplied === false) {
            this.props.applySearchResultsFilter(true);
            this.props.showFilteredResults(this.props.filteredDocuments);
            this.props.paginate(1);
        } else if (this.showLoading() === true) {
            this.props.applySearchResultsFilter(false);
            const { loadingStatus, imagingWindows, alertWindow, ...request } = this.state; // remove UI only fields before submitting
            const request1 = Object.assign(request, { pageNumber: this.props.pageNumber });
		    this.props.searchResultsSort(request1, this.props.currentSearch, this.props.history, this.hideLoading);
        }
    }
    
    handleResetRead = (event) => { 
        event.preventDefault();      
        this.props.resetRead();       
    }

    componentDidMount() {
        this.props.resetRead();  
    }

    render() {
        let formTemplateMarginLeft = 60;
        if (this.props.sideNavigationOpen) {
            formTemplateMarginLeft = 270;
        }

        let buttonIcon = caretSquareDownIcon;
        if (this.state.searchResultsSortDirection === 'ASC') {
          buttonIcon = caretSquareUpIcon;
        }

        let sortByFormGroup =  { layout: 'horizontal', id: 'searchResutlsSort', label: 'Sort by', labelFor: 'searchResutlsSort', fieldType: 'select', value: "N", size: "sm", options: [{ code: "id", description: "Book Reference ID"}, {code: "fromName", description: "From Name"}, {code: "fromDate", description: "From Date"}] }

        let currentSearchLongDescription = this.props.currentSearch ? this.props.currentSearch.longDescription : ""
        let currentSearchCriteria = this.props.currentSearch ? this.props.currentSearch.displayCriteria : []
        let selectButton =  <Button variant="primary" size="sm" aria-label="apply sort" onClick={this.handleClick}> {buttonIcon} </Button>

        let filter = <Button variant='secondary' size="sm" style={{marginLeft: 2, marginBottom: 4}} onClick={this.handleApplyFilter}>{filterIcon} Filter Selections</Button>
        if (this.props.filterApplied === true) {
            filter = <Button variant='secondary' size="sm" style={{marginLeft: 2, marginBottom: 4}} onClick={this.handleApplyFilter}>{minusIcon} Remove Filter</Button>
        }

        let read = <></>
        if (this.props.searchResultsVisitedApplied === true) {
            read = <Button variant='secondary' size="sm" style={{marginLeft: 2, marginBottom: 4}} onClick={this.handleResetRead}>{minusIcon} Reset Read</Button>
        } 

        return (
            <div style={{ marginTop: 4, marginLeft: formTemplateMarginLeft, marginRight: 20, marginBottom: 4, paddingBottom: 4, borderTop: '1px solid lightGray', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)" }} >
                <CountyNotes />
                <PageBanner pageHeading={currentSearchLongDescription} searchCriteria={currentSearchCriteria} />

                <Container fluid="true" >
                    <Row style={{marginRight: 1}}>
                        <Col lg={7} style={{paddingRight: 0}}>
                            {filter} 
                            {read} 
                            <SelectField  size="sm"  formGroup={sortByFormGroup} selectButton={selectButton} onChange={this.handleChange} />
                            <GrantorGranteeBookSearchResultsTable />
                        </Col>

                        <Col lg={5} style={{paddingTop: 2, paddingBottom: 4}}>
                            <GrantorGranteeBookSearchResultsDetails history={this.props.history}/>
                        </Col>
                    </Row>
    
                </Container>
                <Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
            </div>
        )
    }
}

export default connect(mapStateToProps, matchDispatchToProps)(GrantorGranteeBookSearchResults);